import React from 'react';

const SectionHeader = ({ title, description, icon: Icon, className = "" }) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-full">
            <Icon className="h-5 w-5 text-purple-600 dark:text-purple-400" />
          </div>
        )}
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {title}
        </h2>
      </div>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;